import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import styles from './fk-branding.module.css';
import { Container } from '../../components';

import Logotype from '../../public/fitkonnekt/branding/logo.svg';
import Fonts from '../../public/fitkonnekt/branding/fonts.svg';
import Colors from '../../public/fitkonnekt/branding/colors.svg';
import fitkonnekt from '../../public/fitkonnekt/branding/fitkonnekt.jpg';
import business from '../../public/fitkonnekt/branding/business.png';

function FKBranding() {
  return (
    <section className={styles.branding}>
      <Container>
        <AnimationOnScroll
          animateOnce
          duration={1.2}
          offset={400}
          animateIn="animate__fadeInUp"
        >
          <h2 className={styles.branding_title}>
            Bra<span>nding</span>
          </h2>
        </AnimationOnScroll>

        <AnimationOnScroll
          animateOnce
          offset={400}
          duration={1.2}
          animateIn="animate__fadeInUp"
        >
          <div className={styles.logo}>
            <div className={styles.logo_inner}>
              <div className={styles.logo_start}>
                <h3 className={styles.logo_title}>Logo</h3>
                <div className={styles.logo_text}>
                  <p>
                    MAVINX design team worked on the full branding package for
                    the FitKonnekt project.
                  </p>
                </div>
                <div className={styles.logo_text}>
                  <p>
                    The logo represents F letter in the interesting shape and
                    agressive red color.
                  </p>
                </div>
              </div>
              <div className={styles.logo_end}>
                <Logotype />
              </div>
            </div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll
          animateOnce
          duration={1.2}
          offset={400}
          animateIn="animate__fadeInUp"
        >
          <div className={styles.fonts}>
            <div className={styles.fonts_start}>
              <Fonts />
            </div>
            <div className={styles.fonts_end}>
              <h3 className={styles.fonts_title}>Fonts</h3>
              <span className={styles.montserrat}>Montserrat</span>
              <span className={styles.noto}>Noto Sans</span>
            </div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll
          animateOnce
          offset={400}
          duration={1.2}
          animateIn="animate__fadeInUp"
        >
          <div className={styles.colors}>
            <div className={styles.colors_start}>
              <h3 className={styles.colors_title}>Сolors</h3>
              <div className={styles.colors__text}>
                <p>
                  Black is a really good backdrop colour for Red, this
                  combimation represents a fitness mood for the hard workout. In
                  the app we use Red for main elements on the screens, CTA
                  buttons, contrast and illustrated elements. The Black was used
                  for typography and White was implemented mainly for the
                  backgrounds.
                </p>
              </div>
            </div>
            <div className={styles.colors_end}>
              <Colors />
            </div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll
          animateOnce
          duration={1.2}
          offset={400}
          animateIn="animate__fadeInUp"
        >
          <div className={styles.app}>
            <div className={styles.app_start}>
              <div className={styles.app_image}>
                <Image
                  alt="Fitkonnect custom illustration"
                  width={740}
                  height={477}
                  src={fitkonnekt}
                />
              </div>
            </div>
            <div className={styles.app_end}>
              <h3 className={styles.app_title}>App icon</h3>
              <div className={styles.app__text}>
                <p>
                  Custom illustration for the app icon seemed to be very
                  interesting solution. We painted this image trying to
                  represent the fitness app idea that works for everyone.
                </p>
              </div>
            </div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll
          animateOnce
          duration={1.2}
          offset={400}
          animateIn="animate__fadeInUp"
        >
          <div className={styles.businessCard}>
            <div className={styles.businessCard_start}>
              <h3 className={styles.businessCard_title}>Business Card</h3>
              <div className={styles.businessCard__text}>
                <p>
                  The business cards are a standard element of the brandbook
                  package.
                </p>
                <p>
                  We decided to add QR code that leads to the landing page of
                  the project when you scan it from your phone.
                </p>
              </div>
            </div>
            <div className={styles.businessCard_end}>
              <div className={styles.businessCard_image}>
                <Image
                  alt="Fitkonnect business card"
                  width={561}
                  height={428}
                  src={business}
                />
              </div>
            </div>
          </div>
        </AnimationOnScroll>
      </Container>
    </section>
  );
}

export default FKBranding;
